<template>
  <div class="addplace-page container">
    <h1 class="title">Editar tradução (Idioma: {{$route.query.lang}})</h1>
    <div class="page-content">
      <place-translate-form
        :onSubmit="updatePlaceTranslation"
        :is-disabled="isFormDisabled"
        :is-loading="isFormDisabled"
        :form-data="placeTranslation"
        button-label="Atualizar Tradução"
      />
      <p class="has-text-centered">
        <router-link :to="`/${$route.params.lang}/places/${$route.params.id}`" class="button is-link">Visualizar Lugar</router-link>
        <router-link :to="`/${$route.params.lang}/places`" class="button is-link">Voltar para listagem de Lugares</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AsideMenuCtrlMixin from './AsideMenuCtrlMixin'
import PlaceTranslateForm from '../forms/PlaceTranslateForm'
import { UpdatePlaceTranslation } from '../../api/place'
import { prepareFormData } from '../../helpers'

export default {
  name: 'AddPlaceTranslationPage',
  mixins: [AsideMenuCtrlMixin],
  components: { PlaceTranslateForm },
  data () {
    return {
      isFormDisabled: false,
      placeTranslation: {}
    }
  },
  created () {
    const { lang } = this.$route.query
    const { id } = this.$route.params
    if (this.PlaceLanguages.length === 0) {
      this.RetrievePlaceLanguage({ params: { id } })
        .then(
          success => {
            this.placeTranslation = this.PlaceLanguages.find(item => item.language === lang)
          },
          error => {
            console.log(error.response)
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível obter as Traduções do lugar no momento.',
              duration: 10000
            })
          }
        )
    } else {
      this.placeTranslation = this.PlaceLanguages.find(item => item.language === lang)
    }
  },
  computed: {
    ...mapGetters(['PlaceLanguages'])
  },
  methods: {
    ...mapActions(['RetrievePlaceLanguage']),
    updatePlaceTranslation (data) {
      this.isFormDisabled = true
      let formData = {
        ...data,
        id: null,
        createdAt: null,
        updatedAt: null,
        language: null
      }
      UpdatePlaceTranslation(
        prepareFormData(formData),
        this.$route.params.id,
        this.$route.params.translationId
      )
        .then(
          success => {
            this.$modal.open({
              title: 'Sucesso!',
              content: 'Tradução atualizada com sucesso!',
              showCancel: false,
              onOk: () => {
                this.$router.push(`/${this.$route.params.lang}/places`)
              }
            })
            this.isFormDisabled = false
            console.log(success)
          },
          error => {
            console.log(error.response)
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível criar a Tradução agora agora. Tente novamente.',
              duration: 10000
            })
            this.isFormDisabled = false
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/EditPlaceTranslationPage.vue